(function () {
  var root = document.querySelector('.dg-contact');
  if (!root) return;

  var topicSelect = root.querySelector('#dg-contact-topic');
  var orderField = root.querySelector('[data-field="order"]');
  var phoneField = root.querySelector('[data-field="phone"]');
  var messageField = root.querySelector('#dg-contact-message');

  var placeholders = {
    'Order status': 'Include any details about your order — we will look it up and get back to you quickly.',
    'Product question': 'Ask about ingredients, how to use a product, or which Crafted Beards option fits your routine.',
    'Return or refund': 'Tell us what happened and whether the product was opened. We will guide you through next steps.',
    Wholesale: 'Tell us about your business and what you are interested in carrying.',
    Other: 'How can we help you today?'
  };

  function updateFormFields() {
    if (!topicSelect) return;
    var topic = topicSelect.value;
    var showOrder = topic === 'Order status' || topic === 'Return or refund';
    var showPhone = topic === 'Order status' || topic === 'Return or refund';

    if (orderField) {
      orderField.classList.toggle('is-hidden', !showOrder);
      var orderInput = orderField.querySelector('input');
      if (orderInput) orderInput.disabled = !showOrder;
    }
    if (phoneField) {
      phoneField.classList.toggle('is-hidden', !showPhone);
      var phoneInput = phoneField.querySelector('input');
      if (phoneInput) phoneInput.disabled = !showPhone;
    }
    if (messageField && placeholders[topic]) {
      messageField.placeholder = placeholders[topic];
    }
  }

  if (topicSelect) {
    topicSelect.addEventListener('change', updateFormFields);
    updateFormFields();
  }
})();
